import { loadSvg } from "@/lib/utils/svg/loadSvg";
import { useEffect } from "react";

export const usePreloadSvgIcons = (urls: string[]) => {
  useEffect(() => {
    if (!urls?.length) return;

    Array.from(new Set(urls)).forEach((url) => {
      loadSvg(url);
    });
  }, [JSON.stringify(urls)]);
};
